export enum ValidationModeEnum {
    preview = 0,
    createSession = 2,
    validation = 3,
    review = 4,
    report = 5,
}
